import { Checkbox, Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetsResultsMessagesSection } from 'Components/Worksheets/Core';

let BsEnResultsSection: React.FC<IWorksheetComponent> = () => {
  return (
    <>
      <WorksheetsResultsMessagesSection />
      <ListFieldSection wide>
        <Field input={<TextOutput />} name="Results.MoistureContentPercent" />
      </ListFieldSection>
      <ListFieldSection heading="Report">
        <Field input={<Checkbox />} name="Results.ReportMass" />
      </ListFieldSection>
    </>
  );
};

BsEnResultsSection = withInjectedProps(BsEnResultsSection);

export { BsEnResultsSection };
export default BsEnResultsSection;
